/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

 require('./bootstrap');

 import { createApp } from 'vue'

 // import VueToast from 'vue-toast-notification'
 // import 'vue-toast-notification/dist/theme-sugar.css'
 // Vue.use(VueToast)

//  import VeeValidate from 'vee-validate';
 // Vue.use(VeeValidate);

 import {createWebHistory, createRouter} from "vue-router"
 // import VueRouter from 'vue-router'
 // Vue.use(VueRouter);

 // Vue.component('hamlet-pagination', require('laravel-vue-pagination'));

 /**
  * The following block of code may be used to automatically register your
  * Vue components. It will recursively scan this directory for the Vue
  * components and automatically register them with their "basename".
  *
  * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
  */

 // const files = require.context('./', true, /\.vue$/i)
 // files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key)))

 // Vue.component('example-component', require('./components/ExampleComponent.vue'));

 const routes = [
     { path: '/users/', component:  () => import('./components/users/UserIndex.vue')},
     { path: '/users/login', name:'users.login', component:  () => import('./components/users/UserLoginRegister.vue')},
     { path: '/users/register', component:  () => import('./components/users/UserRegister.vue')},
     { path: '/users/favorites', component:  () => import('./components/users/UserFavorite.vue')},

     { path: '/users/password/forget', component:  () => import('./components/users/UserPasswordForget.vue')},

    //  { path: '/users/password/forget/old', component:  () => import('./components/users/UserPasswordForgetOld.vue')},
    { path: '/users/reactive/old', component:  () => import('./components/users/UserReactiveOld.vue')},

     { path: '/users/password/reset', component:  () => import('./components/users/UserPasswordReset.vue')},

     { path: '/users/cash', component:  () => import('./components/users/UserStoredCash.vue')},
     { path: '/users/bonus', component:  () => import('./components/users/UserBonus.vue')},
     { path: '/users/coupon', component:  () => import('./components/users/UserCoupon.vue')},
     { path: '/users/profile', component:  () => import('./components/users/UserProfile.vue')},
     { path: '/users/mobile/validate', component:  () => import('./components/users/UserMobileValidate.vue')},
     { path: '/users/addressbook', component:  () => import('./components/users/UserAddressBook.vue')},
     { path: '/users/binding', component:  () => import('./components/users/UserBinding.vue')},

     { path: '/users/thirdparty/check', component:  () => import('./components/users/UserThirdpartyCheck.vue')},
     { path: '/users/reactive/check', component:  () => import('./components/users/UserReactiveCheck.vue')},

     { path: '/cart', component:  () => import('./components/Cart.vue')},
     // { path: '/cart/step2', component:  require('./components/CartStep2.vue')},
     { path: '/users/orders/:orderNo/done', component:  () => import('./components/orders/OrderDone.vue')},
     { path: '/users/orders_done/:orderNo', component:  () => import('./components/orders/OrderDone.vue')},
     { path: '/users/orders/', component:  () => import('./components/orders/OrderList.vue')},
     { path: '/users/orders/:orderSubNo', component:  () => import('./components/orders/OrderSub.vue'), props: true},

     { path: '/users/orders/:orderSubNo/rating', component:  () => import('./components/orders/OrderSubRating.vue')},
 ];
 // const router = new VueRouter({
 //     mode: 'history',
 //     routes: routes
 // })

 const router = createRouter({
     history: createWebHistory(),
     routes,
 })

 // router.afterEach(() => {
 //     console.log('bye');
 // });

 /**
  * Next, we will create a fresh Vue application instance and attach it to
  * the page. Then, you may begin adding components to this application
  * or customize the JavaScript scaffolding to fit your unique needs.
  */

 const app = createApp({

 })
 .use(router)
//  .use(VeeValidate)

 const vm = app.mount('#app')

 window.app = app
 window.vm = vm

//  const app = new Vue({
//      el: '#app',
//      router:router
//  });

